var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-floating',{attrs:{"isNearBorder":"","rightMargin":0,"bottomMargin":20},on:{"tap":_vm.floatingTap}},[_c('div',{staticClass:"floatingView"})])}
var staticRenderFns = []

export { render, staticRenderFns }